import React, { useEffect, useState } from 'react';
import { IoCall } from 'react-icons/io5';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Modal = ({ isOpen, onClose, phoneNumbers }) => {
    // Disable scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup on component unmount or when modal closes
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <h2>Order Now!</h2>
        {phoneNumbers.length > 0 ? (
          <div>
            {phoneNumbers.map((number, index) => (
              <button
                key={index}
                className="phone-number-button"
                onClick={() => (window.location.href = `tel:${number}`)}
              >
                Call {number}
              </button>
            ))}
          </div>
        ) : (
          <p>No phone numbers available.</p>
        )}
      </div>
    </div>
  );
};


const MenuItem = ({ item }) => {
  return (
    <div className="section">
      <article className="menu-item">
        <div className="child">
          {item.img && (
            <LazyLoadImage
              src={item.img}
              alt={item.title}
              className="photo"
            />
          )}
          <div className="item-info">
            <header>
              {item.title && <h4>{item.title}</h4>}
              <br />
              {item.price && <h4 className="price">Rs {item.price}</h4>}
            </header>
          </div>
        </div>
        {item.description && <div className="desc">[ {item.description}.]</div>}
        {item.time && <div className="time">{item.time} only</div>}
      </article>
    </div>
  );
};

const MenuPage = ({ menu1 }) => {
  const [menuContent, setMenuContent] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubcategory, setSelectedSubcategory] = useState('');
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [showPhoneModal, setShowPhoneModal] = useState(false);

  useEffect(() => {
    if (!menu1) {
      setMenuContent('Error');
      return;
    }

    fetch(menu1)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch menu content');
        }
        return response.json();
      })
      .then((data) => {
        setMenuContent(data);

         const numbers = data
        .flatMap((item) => item.phoneNumber) // Ensure all phone numbers are captured
        .filter(Boolean); // Remove any undefined or null values

      setPhoneNumbers(numbers); // Remove extra spaces
    })
      .catch(() => {
        setMenuContent('Error');
      });
  }, [menu1]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setSelectedSubcategory('');
  };

  const handleSubcategoryClick = (subcategory) => {
    setSelectedSubcategory(subcategory);
  };


  const handleAllClick = () => {
    setSelectedCategory('');
    setSelectedSubcategory('');
  };

  const handleClosePhoneModal = () => {
    setShowPhoneModal(false);
  };

  if (menuContent === 'Error') {
    return (
      <div id="error-page">
        <div className="content">
          <h2 className="header" data-text="404">404</h2>
          <h4 data-text="Oops! Page not found">Oops! Page not found</h4>
          <p>Sorry, the page you're looking for doesn't exist. If you think something is broken, report a problem.</p>
        </div>
      </div>
    );
  }

  if (!menuContent) {
    return (
      <div className="wrap">
        <div className="spinner"></div><br />
        <h3>Please wait while your menu is Loading</h3>
      </div>
    );
  }
let filteredMenuContent = menuContent;

  if (selectedCategory) {
    filteredMenuContent = menuContent.filter(
      (item) =>
        item.category === selectedCategory &&
        (!selectedSubcategory || item.subcategory === selectedSubcategory)
    );
  }

  const categoryHeadings = {};

  if (!selectedCategory) {
    filteredMenuContent.forEach((menuItem) => {
      const category = menuItem.category;
      const subcategory = menuItem.subcategory;

      if (!categoryHeadings[category]) {
        categoryHeadings[category] = {};
      }

      if (!categoryHeadings[category][subcategory]) {
        categoryHeadings[category][subcategory] = [];
      }

      categoryHeadings[category][subcategory].push(menuItem);
    });
  }


  return (
    <div>
      <div className="centered-container">
        {menuContent[0]?.logo && (
          <LazyLoadImage
            src={menuContent[0].logo}
            alt="Menu Logo"
            effect="blur"
            className="menu-logo"
          />
        )}
      </div>

      <div className="menu-container">
        <div className="filter-buttons">
          <button
            onClick={handleAllClick}
            className={!selectedCategory && !selectedSubcategory ? 'active' : ''}
          >
            All
          </button>
          {Array.from(new Set(menuContent.map((item) => item.category))).map(
            (category, index) => (
              <button
                key={index}
                onClick={() => setSelectedCategory(category)}
                className={category === selectedCategory ? 'active' : ''}
              >
                {category}
              </button>
            )
          )}
        </div>
     {selectedCategory && (
          <div className="subcategory-buttons">
            {Array.from(
              new Set(
                menuContent
                  .filter((item) => item.category === selectedCategory && item.subcategory)
                  .map((item) => item.subcategory)
              )
            ).map((subcategory, index) => (
              <button
                key={index}
                onClick={() => handleSubcategoryClick(subcategory)}
                className={subcategory === selectedSubcategory ? 'active' : ''}
              >
                {subcategory}
              </button>
            ))}
          </div>
        )}


        <div className="menu-items-container">
          {phoneNumbers.length > 0 && (
            <button
              className="Pay-now"
              onClick={() => setShowPhoneModal(true)}
            >
              <IoCall />
            </button>
          )}

         
      {selectedCategory
            ? filteredMenuContent.map((menuItem, index) => (
                <MenuItem key={index} item={menuItem} />
              ))
            : Object.entries(categoryHeadings).map(([category, subcategories], index) => (
                <div key={index}>
                  {category && <h3 className="heading">{category}</h3>}
                  {Object.entries(subcategories).map(([subcategory, items], subIndex) => (
                    <div key={subIndex}>
                      {subcategory && <h4 className="subheading">{subcategory}</h4>}
                      {items.map((menuItem, itemIndex) => (
                        <MenuItem key={itemIndex} item={menuItem} />
                      ))}
                    </div>
                  ))}
                </div>
              ))}
        </div>
      </div>
   

      {/* Modal */}
      <Modal
        isOpen={showPhoneModal}
        onClose={handleClosePhoneModal}
        phoneNumbers={phoneNumbers}
      />
    </div>
  );
};

export default MenuPage;
